// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"b7a3430c","513":"7d0a292b","787":"0176656a"}[chunkId] + ".chunk.js";
};